/* eslint-disable */
import { useTranslation } from "react-i18next";

export default function DetailsSmartSuivi() {
  const { t } = useTranslation();

  return (
    <div className="min-h-[420px] h-fit dark:!bg-[#181919]">
      <section className="cta-sec relative max-w-screen-xl px-4 md:px-8 h-fit mt-5 pt-0">
        <div className="flex flex-col md:flex-row">
          <div className="flex-1">
            <h3 className="text-2xl font-bold text-gray-800 dark:!text-gray-200 mb-4">
              {t("servicePageDetails.smartsuivi.title")}{" "}
              <span className="text-[#9e68ba] dark:!text-[#bc7ade]">
                {t("servicePageDetails.smartsuivi.highlight")}
              </span>
            </h3>

            <p className="text-gray-600 dark:!text-gray-300 mb-6 leading-relaxed">
              {t("servicePageDetails.smartsuivi.description")}
            </p>

            <div className="bg-[#fcf6ff] dark:!bg-[#222222] p-4 rounded-lg border border-[#fbf4ff] dark:!border-[#3c3a3d] mb-4">
              <h4 className="font-medium text-[#9e68ba] dark:!text-[#bc7ade] mb-2">
                {t("servicePageDetails.smartsuivi.featuresTitle")}
              </h4>

              <ul className="space-y-2 text-gray-700 dark:!text-gray-300">
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                  {t("servicePageDetails.smartsuivi.features.feature1")}
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                  {t("servicePageDetails.smartsuivi.features.feature2")}
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                  {t("servicePageDetails.smartsuivi.features.feature3")}
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                  {t("servicePageDetails.smartsuivi.features.feature4")}
                </li>
                <li className="flex items-center">
                  <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                  {t("servicePageDetails.smartsuivi.features.feature5")}
                </li>
              </ul>
            </div>

            {/*
            <a
              className="inline-flex items-center px-4 py-2 text-[#9e68ba] dark:!text-[#bc7ade] bg-[#fcf6ff] dark:!bg-[#222222] rounded-lg font-medium transition-colors hover:bg-[#faf1ff] dark:hover:!bg-[#2c2c2c]"
              href=""
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 ml-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                <path
                  fillRule="evenodd"
                  d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                  clipRule="evenodd"
                />
              </svg>
              {t("servicePageDetails.smartsuivi.videoButton")}
            </a>
            */}
          </div>

          {/* <div className="flex-1 mx-auto sm:w-9/12 lg:mt-0 h-fit lg:w-auto mr-2">
            <img
              src="/SmartSuivi.jpeg"
              alt="Smart Suivi"
              className="w-full rounded-xl border border-[#fbf4ff] dark:!border-[#3c3a3d]"
            />
          </div> */}
        </div>
      </section>
    </div>
  );
}
